import { createFullCycleActions, createMiddlewares } from 'utils/actions'
import _ from 'lodash'
import update from 'immutability-helper'
import toastr from '@zanroo/react-redux-toastr-arun'
import * as apis from 'apis/crm/postBlocker'

const Actions = {
  settings: createFullCycleActions({
    prefix: 'actions.crm.postBlocker.settings',
    customMiddlewares: (actions) => ({
      list: createMiddlewares({
        caller: apis.ListPostBlocker,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          await dispatch(actions.default.set(data))
        }
      }),
      create: createMiddlewares({
        caller: apis.CreatePostBlocker,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'crm.postBlocker.settings.default', {})
          const updated = update(defaultData, {
            items: {
              $push: [data]
            }
          })

          await dispatch(actions.default.set(updated))

          toastr.success('SUCCESS', 'Setting has been created.')
        }
      }),
      update: createMiddlewares({
        caller: apis.UpdatePostBlocker,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'crm.postBlocker.settings.default', {})

          const index = _.findIndex(defaultData.items, { _id: data._id })

          if (index < 0) {
            return
          }

          const updated = update(defaultData, {
            items: {
              [index]: { $set: data }
            }
          })

          await dispatch(actions.default.set(updated))
          toastr.success('SUCCESS', 'Setting has been updated.')
        }
      }),
      del: createMiddlewares({
        caller: apis.DeletePostBlocker,
        actionApi: actions.api,
        dispatcher: ({ data, statusCode, message }) => async (dispatch, getState) => {
          if (statusCode !== 20000) {
            toastr.error('ERROR', message)
            return
          }
          const state = getState()
          const defaultData = _.get(state, 'crm.postBlocker.settings.default', {})
          const index = _.findIndex(defaultData.items, { _id: data._id })

          if (index < 0) {
            return
          }

          const updated = update(defaultData, {
            items: { $splice: [[index, 1]] }
          })

          await dispatch(actions.default.set(updated))
          toastr.success('SUCCESS', 'Setting has been deleted.')
        }
      })
    })
  })
}

export default Actions
